import type { RowSliderData } from "~/core/types";

export const isRowSlider = (row: unknown): row is RowSliderData => {
  return (
    typeof row === "object" &&
    row !== null &&
    "__typename" in row &&
    row.__typename === "rowSlider"
  );
};
